import React from "react";
import CheckRegisterReviewTab from "./checkRegisterReviewTab.jsx";
import "./invoiceReview.scss";

const InvoiceReviewCheckRegistersPage = () => (
    <div className="container invoice-review">
        <p className="title">Review Check-Registers</p>
        <p className="sub-title">HRP-generated check-registers pending approval.</p>
        <CheckRegisterReviewTab />
    </div>
);

export default InvoiceReviewCheckRegistersPage;
